import {
    FETCH_CREATE_ACTOR_TYPES_REQUEST,
    FETCH_CREATE_ACTOR_TYPES_SUCCESS,
    FETCH_CREATE_ACTOR_TYPES_FAILURE,
} from '../../actions/actorTypes/create-actorTypes-action';

const initialState = {
    createdActorType: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateActorTypeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_ACTOR_TYPES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_ACTOR_TYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdActorType: { ...action.payload[0] },
            };
        case FETCH_CREATE_ACTOR_TYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateActorTypeReducer;